/**
 * Created by zhaoyao on 2022/10/25
 * Desc: 信息服务费
 */

import React, { Component } from 'react'
import { Picker, List, Toast } from "antd-mobile";
import { fetchGet, fetchPost, fetchPostObj } from '../../utils/fetchRequest'
import { API } from '../../configs/api.config'
import { getSearchParams, isObjEmpty } from '../../utils/common'
import { switchUser } from '../../redux/actions/userInfo'
import { Icon, message, Button, Cascader } from 'antd'
import { getIntValue, getStrValue, isObjNull } from '../../utils/common'
import './ServiceApply.css';
import { connect } from 'react-redux'

class ServiceApply extends Component {

    componentWillMount() {
        document.title = "信息服务费";
    }

    constructor() {
        super()

        this.state = {
            appId: null,
            openId: null,
            schoolData: [],
            schoolValue: [],
            gradeClazz: '',
            stuName: null,
            psName: null,
            psPhone: null,
            psRelation: null
        }
    }

    componentDidMount() {
        Toast.loading('努力加载中...', 0)
        this.getSchoolList()

        this.searchParams = getSearchParams(this.props.location.search)
        this.setState({
            appId: this.searchParams.appId,
            openId: this.searchParams.openId,
        })
    }

    handleSchoolChange = (v) => {
        console.log(v)
        this.setState({ schoolValue: v })
        //this.getSchoolList(this.state.schoolData[v])
    }

    render() {
        const { schoolData, schoolValue, gradeClazz, stuName, psName, psPhone, psRelation } = this.state;

        return (
            <div className="common-column-layout" ref={node => this.node = node} onChange={this.handelValueCom} style={{ fontFamily: "PingFangSC-Regular", letterSpacing: 2.5 }}>
                <div className="comhline_sty"></div>

                <Picker data={schoolData} title='学校' extra='请选择'
                    value={schoolValue} onChange={this.handleSchoolChange} cols={1}>
                    <List.Item arrow="horizontal">选择学校</List.Item>
                </Picker>

                {/*<div className="item_sty">
                    <div className="left_title">学校</div><div className={'form-input-fill'}>*</div>
                    <input ref='schoolName' className="text-right right_input" type="text" placeholder="请输入" maxLength={20} autoFocus="autoFocus" value={this.state.schoolName}/>
                </div>*/}

                <div className="comhline_sty1"></div>

                <div className="item_sty">
                    <div className="left_title">年级班级</div><div className={'form-input-fill'}>*</div>
                    <input ref='gradeClazz' className="text-right right_input" type="text" placeholder="请输入" maxLength={20} autoFocus="autoFocus" defaultValue={this.state.gradeClazz} />
                </div>

                <div className="comhline_sty1"></div>

                <div className="item_sty">
                    <div className="left_title">学生姓名</div><div className={'form-input-fill'}>*</div>
                    <input ref='stuName' className="text-right right_input" type="text" placeholder="请输入" maxLength={20} autoFocus="autoFocus" defaultValue={this.state.stuName} />
                </div>

                <div className="comhline_sty1"></div>

                <div className="item_sty">
                    <div className="left_title">家长姓名</div><div className={'form-input-fill'}>*</div>
                    <input ref='psPhone' className="text-right right_input" type="text" placeholder="请输入" maxLength={20} autoFocus="autoFocus" defaultValue={this.state.psPhone} />
                </div>

                <div className="comhline_sty1"></div>

                <div className="item_sty">
                    <div className="left_title">家长手机号</div><div className={'form-input-fill'}>*</div>
                    <input ref='psName' className="text-right right_input" type="text" placeholder="请输入" maxLength={20} autoFocus="autoFocus" defaultValue={this.state.psName} />
                </div>

                <div className="comhline_sty1"></div>

                <div className="item_sty">
                    <div className="left_title">关系</div>
                    <input ref='psRelation' className="text-right right_input" type="text" placeholder="请输入" maxLength={20} autoFocus="autoFocus" defaultValue={this.state.psRelation} />
                </div>

                <div className="comhline_sty"></div>

                <Button className='commonButton' type='primary' style={{ margin: '35px', borderRadius: 30 }}
                    onClick={this.onNextClick}>下一步</Button>
            </div>
        )
    }

    getSchoolList = () => {
        Toast.loading('', 0);

        fetchGet(API.SCHOOL_SERVICE_LIST, {
            // schoolId: this.props.userInfo.teacher.schoolId,
        }).then(response => {
            Toast.hide();
            const { schoolData, schoolValue } = this.state;
            schoolData.length = 0;
            schoolValue.length = 0;
            if (response && response.data) {
                // const schoolArray = response.data.schools
                const propertyArray = response.data;

                if (!isObjEmpty(propertyArray)) {

                    propertyArray.forEach((hrObj, index) => {
                        if (hrObj) {
                            schoolData.push({
                                label: getStrValue(hrObj, 'schoolName'),
                                value: getIntValue(hrObj, 'schoolId'),
                                schoolName: getStrValue(hrObj, 'schoolName'),
                            })
                        }
                    });

                }
            }

            if (schoolData.length > 0) {
                schoolValue.push(schoolData[0].value)
                this.setState({
                    schoolData,
                    schoolValue
                })
            }
            console.log('schoolData', schoolData);
            console.log('schoolValue', schoolValue);
        }).catch(error => {
            Toast.hide();

            if (typeof error === 'string') {
                Toast.fail(error, 2)
            } else {
                Toast.fail('请求异常', 2)
            }
        })
    };

    onNextClick = () => {

        const { schoolValue, gradeClazz, stuName, psName, psPhone, psRelation, appId, openId } = this.state

        if (isObjEmpty(schoolValue)) {
            Toast.fail("请选择学校");
            return;
        }
        if (isObjEmpty(gradeClazz)) {
            Toast.fail('请输入年级班级')
            return
        }
        if (isObjEmpty(stuName)) {
            Toast.fail('请输入学生姓名')
            return
        }
        if (isObjEmpty(psName)) {
            Toast.fail('请输入家长姓名')
            return
        }
        if (isObjEmpty(psPhone)) {
            Toast.fail('请输入家长电话')
            return
        }

        const paramObj = {
            school_id: schoolValue[0],
            gradeClazz: gradeClazz,
            stu_name: stuName,
            parents_name: psName,
            parents_phone: psPhone,
            parents_relation: psRelation,
        }

        fetchPostObj(API.POST_CARD_SAVE, paramObj,
            { "Content-Type": 'application/json;charset=UTF-8' })
            .then(response => {
                Toast.hide()
                if (response && response.data) {

                    //this.props.history.push('/serviceExplain/'+response.data.id +'/'+ appId +'/'+ openId);
                    this.props.history.push('/servicePayCost/' + response.data.id + '/' + appId + '/' + openId + '/' + schoolValue[0]);
                }

            }).catch(error => {
                Toast.hide()

                if (typeof error === 'string') {
                    Toast.fail(error, 2)
                } else {
                    Toast.fail('请求异常', 2)
                }
            })
    }

    handelValueCom = (event) => {
        //获取用户名的值
        let gradeClazz = this.refs.gradeClazz.value;
        let stuName = this.refs.stuName.value;
        let psName = this.refs.psName.value;
        let psPhone = this.refs.psPhone.value;
        let psRelation = this.refs.psRelation.value;
        //获得内容的值
        this.setState({
            gradeClazz: gradeClazz,
            stuName: stuName,
            psName: psName,
            psPhone: psPhone,
            psRelation: psRelation,
        })
    }

}

let mapStateToProps = (state) => ({
    userInfo: { ...state.redUserInfo }
})

let mapDispatchToProps = (dispatch) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(ServiceApply)
